module.exports = __webpack_public_path__ + "img/arm-header-icons-hover-01.efc870a5.svg";